export default class FellowsRelated {
	constructor() {
		this.node = document.querySelector('.single-fellows');

		if (!this.node) {
			return;
		}

		this.postList = this.node.querySelector('.post-list');
		this.postItems = this.node.querySelector('.post-list__items');

		//check for .single-fellows .post-list__items, if empty, hide .post-list
		if (this.postItems.innerHTML.trim().length == 0) {
			this.postList.hidden = true;
		}
	}

};



